import { OldName, OldNameToJSON } from '@/api'

export interface UpdateUserRequest {
  id: string
  userType: string
  expirationDate: string
  state: string
  studentGrade: string
  studentClass: string
  studentNumber: string
  registeredDate: string
  branchCode: string
  myBranchCode: string
  myPlaceCode: string
  reserveReceivePlaceCode: string
  name: string
  nameKana: string
  birthday: string // birthdayJapaneseSymbolと結合した値とする
  gender: string
  phoneNumbers: {
    id: number
    contact: boolean
    number: string
    type: string
  }[]
  addressCode: string
  zipCode: string
  areaCode: string
  address: string
  mailAddresses: {
    id: number
    address: string
    reserve: boolean
    newArrival: boolean
    remind: boolean
    notice: boolean
    event: boolean
    type: string
  }[]
  reserveNotice: string
  opacPassword: string
  opacMyPageEnabled: boolean
  opacMyReserveEnabled: boolean
  remindExclude: string
  suspendReason: string
  suspendLimit: string
  cardLostCount: number
  cardLostReissue: string
  cardLostDate: string
  disability: boolean
  readingSupportEnabled: boolean
  guardian: string
  guardianKana: string
  workType: string
  otherContacts: {
    id: number
    type: string
    name: string
  }[]
  userFamilyId: number | null
  familyUsers: { id: string }[]
  userOldNames: OldName[]
  userOldAddresses: {
    id: number
    addressCode: string
    address: string
  }[]
  userNewArrivalNoticeGenres: string[]
  userNewArrivalNoticeKeywords: string[]
  revision: number
}

export function UpdateUserRequestToJSON(value: UpdateUserRequest): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    user_type: value.userType !== '' ? value.userType : undefined,
    expiration_date:
      value.expirationDate !== '' ? value.expirationDate : undefined,
    state: value.state !== '' ? value.state : undefined,
    student_grade: value.studentGrade !== '' ? value.studentGrade : undefined,
    student_class: value.studentClass !== '' ? value.studentClass : undefined,
    student_number:
      value.studentNumber !== '' ? value.studentNumber : undefined,
    registered_date:
      value.registeredDate !== '' ? value.registeredDate : undefined,
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    my_branch_code: value.myBranchCode !== '' ? value.myBranchCode : undefined,
    my_place_code: value.myPlaceCode !== '' ? value.myPlaceCode : undefined,
    reserve_receive_place_code:
      value.reserveReceivePlaceCode !== ''
        ? value.reserveReceivePlaceCode
        : undefined,
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    birthday: value.birthday !== '' ? value.birthday : undefined,
    gender: value.gender !== '' ? value.gender : undefined,
    phone_numbers:
      value.phoneNumbers.length > 0
        ? value.phoneNumbers.map(phoneNumber => ({
            id: phoneNumber.id,
            contact: phoneNumber.contact,
            number: phoneNumber.number,
            type: phoneNumber.type
          }))
        : undefined,
    address_code: value.addressCode !== '' ? value.addressCode : undefined,
    zip_code: value.zipCode !== '' ? value.zipCode : undefined,
    area_code: value.areaCode !== '' ? value.areaCode : undefined,
    address: value.address !== '' ? value.address : undefined,
    mail_addresses:
      value.mailAddresses.length > 0
        ? value.mailAddresses.map(mailAddress => ({
            id: mailAddress.id,
            address: mailAddress.address,
            reserve: mailAddress.reserve,
            new_arrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: mailAddress.type
          }))
        : undefined,
    reserve_notice:
      value.reserveNotice !== '' ? value.reserveNotice : undefined,
    opac_password: value.opacPassword !== '' ? value.opacPassword : undefined,
    opac_my_page_enabled: value.opacMyPageEnabled ?? undefined,
    opac_reserve_enabled: value.opacMyReserveEnabled ?? undefined,
    remind_exclude:
      value.remindExclude !== '' ? value.remindExclude : undefined,
    suspend_reason:
      value.suspendReason !== '' ? value.suspendReason : undefined,
    suspend_limit: value.suspendLimit !== '' ? value.suspendLimit : undefined,
    card_lost_count:
      value.cardLostCount !== 0 ? value.cardLostCount : undefined,
    card_lost_reissue:
      value.cardLostReissue !== '' ? value.cardLostReissue : undefined,
    card_lost_date: value.cardLostDate !== '' ? value.cardLostDate : undefined,
    disability: value.disability ?? undefined,
    reading_support_enabled: value.readingSupportEnabled ?? undefined,
    guardian: value.guardian !== '' ? value.guardian : undefined,
    guardian_kana: value.guardianKana !== '' ? value.guardianKana : undefined,
    work_type: value.workType !== '' ? value.workType : undefined,
    other_contacts:
      value.otherContacts.length > 0
        ? value.otherContacts.map(otherContact => ({
            id: otherContact.id,
            type: otherContact.type,
            name: otherContact.name
          }))
        : undefined,
    user_family_id:
      value.userFamilyId !== 0 && value.userFamilyId !== null
        ? value.userFamilyId
        : undefined,
    family_users: value.familyUsers.length > 0 ? value.familyUsers : undefined,
    user_old_names:
      value.userOldNames.length > 0
        ? value.userOldNames.map(OldNameToJSON)
        : undefined,
    user_old_addresses:
      value.userOldAddresses.length > 0
        ? value.userOldAddresses.map(userOldAddress => ({
            id: userOldAddress.id,
            address_code: userOldAddress.addressCode,
            address: userOldAddress.address
          }))
        : undefined,
    user_new_arrival_notice_genres:
      value.userNewArrivalNoticeGenres.length > 0
        ? value.userNewArrivalNoticeGenres
        : undefined,
    user_new_arrival_notice_keywords:
      value.userNewArrivalNoticeKeywords.length > 0
        ? value.userNewArrivalNoticeKeywords
        : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
